import React, { memo, SVGProps } from 'react'

export const FileUploadNegative = memo((props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.04 0.66999L22.12 6.74999H22.11C22.22 6.86999 22.29 7.01999 22.29 7.18999V22.89C22.29 23.23 22.01 23.51 21.67 23.51H2.32996C1.98996 23.51 1.70996 23.23 1.70996 22.89V1.10999C1.70996 0.76999 1.98996 0.48999 2.32996 0.48999H15.6C15.76 0.48999 15.92 0.54999 16.04 0.66999ZM7.41996 11.69L11.76 7.14998H11.75C11.88 7.00998 12.1 7.00998 12.23 7.14998L16.57 11.69C16.77 11.9 16.62 12.25 16.33 12.25H15.13C14.95 12.25 14.8 12.4 14.8 12.58V16.76C14.8 16.94 14.65 17.09 14.47 17.09H9.51996C9.33996 17.09 9.18996 16.94 9.18996 16.76V12.58C9.18996 12.4 9.03996 12.25 8.85996 12.25H7.65996C7.36996 12.25 7.21996 11.9 7.41996 11.69Z"
      fill="currentColor"
    />
  </svg>
))
